
import { connect } from "react-redux";
import { Wlf_View } from "./wlf";
import { navigatePath } from "../../nav/actions";
import { setOnboardingData } from "../../onboarding/actions";
import { tdaUpdate } from "../../tda/actions";
import { dwollaUpdate } from "../../payment/actions";
import {loadAccountData} from "../../dashboard/user/actions";
import {setWlfAUM} from "../../app/actions";
import {setSecurityBreakpoints} from "../../superadmin/security-purchase-reducer";

const mapDispatchToProps = dispatch => {
  return {
    navigatePath: (path, args) => {dispatch(navigatePath(path, args))},
    setOnboardingData: (onboarding, index, username) => dispatch(setOnboardingData(onboarding, index, username)),
    tdaUpdate: (data, index, username) => dispatch(tdaUpdate(data, index, username)),
    dwollaUpdate: (dwolla, index, username) => dispatch(dwollaUpdate(dwolla, index, username)),
    loadAccountData:
      (username, acct_index, date, chart_colors) => dispatch(loadAccountData(username, acct_index, date, chart_colors)),
    setWlfAUM: (aum) => dispatch(setWlfAUM(aum)),
    setSecurityBreakpoints: (breakpoints) => dispatch(setSecurityBreakpoints(breakpoints)),
  };
};

const mapStateToProps = state => {
  return {
    token: state.user.token,
    onboarding: state.onboarding,
    client: state.client,
    app: state.app,
    wlf_id: state.app.wlf && state.app.wlf.id,
    user: state.user,
    userDashboard: state.userDashboard,
    securityPurchase: state.securityPurchase,
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(Wlf_View);
